// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__q7V3z","box":"styles_box__4f_RE","error":"styles_error__35IO7"};